import React from 'react';
import { Card, CardHeader, CardBody, Heading, Text, Table, Tbody, Tr, Td, Accordion, AccordionItem, AccordionButton, AccordionPanel, AccordionIcon, Box, Spinner } from '@chakra-ui/react';

const TechReportMetadataPanel = ({ metadata, isLoading }) => {
  if (isLoading) {
    return (
      <Accordion allowToggle mb={6}>
        <AccordionItem border="none">
          <Card borderLeft="4px solid" borderColor="orange.400">
            <CardHeader p={0}>
              <AccordionButton _hover={{ bg: 'orange.50' }} p={4}>
                <Box flex="1" textAlign="left">
                  <Heading size="md" color="orange.700">Tech Report Metadata</Heading>
                </Box>
                <AccordionIcon />
              </AccordionButton>
            </CardHeader>
            <AccordionPanel pb={4}>
              <CardBody pt={0}>
                <Spinner size="sm" />
                <Text ml={3} display="inline-block" color="gray.500">Loading metadata...</Text>
              </CardBody>
            </AccordionPanel>
          </Card>
        </AccordionItem>
      </Accordion>
    );
  }

  if (!metadata) return null;

  return (
    <Accordion allowToggle mb={6}>
      <AccordionItem border="none">
        <Card borderLeft="4px solid" borderColor="orange.400">
          <CardHeader p={0}>
            <AccordionButton _hover={{ bg: 'orange.50' }} p={4}>
              <Box flex="1" textAlign="left">
                <Heading size="md" color="orange.700">Tech Report Metadata</Heading>
              </Box>
              <AccordionIcon />
            </AccordionButton>
          </CardHeader>
          <AccordionPanel pb={4}>
            <CardBody pt={0}>
              <Table variant="simple" size="sm">
                <Tbody>
                  {Object.entries(metadata).map(([key, value]) => (
                    <Tr key={key}>
                      <Td fontWeight="bold" width="30%">
                        {key.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())}
                      </Td>
                      <Td>{value}</Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            </CardBody>
          </AccordionPanel>
        </Card>
      </AccordionItem>
    </Accordion>
  );
};

export default TechReportMetadataPanel;
